"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FormControl = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _icons = require("../../assets/icons");

var _elements = require("../../styles/elements");

var _Field = require("./Field.styles");

var _Tooltip = _interopRequireWildcard(require("../Tooltip/Tooltip"));

var _CopyText = _interopRequireDefault(require("../CopyText/CopyText"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Help = _interopRequireDefault(require("./Help/Help"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Tag = (0, _base["default"])("div", {
  target: "e1lqdusd1",
  label: "Tag"
})(_Field.styles.tagStyle, ";");
var FormControl = (0, _base["default"])("div", {
  target: "e1lqdusd0",
  label: "FormControl"
})(_Field.styles.formControlStyle, ";");
exports.FormControl = FormControl;
var Field = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var label = _ref.label,
      name = _ref.name,
      htmlType = _ref.htmlType,
      className = _ref.className,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      validateStatus = _ref.validateStatus,
      help = _ref.help,
      tagPosition = _ref.tagPosition,
      tagContent = _ref.tagContent,
      innerButton = _ref.innerButton,
      showCopy = _ref.showCopy,
      copyText = _ref.copyText,
      disabled = _ref.disabled,
      tooltipTitle = _ref.tooltipTitle,
      tooltipPosition = _ref.tooltipPosition,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["label", "name", "htmlType", "className", "onFocus", "onBlur", "validateStatus", "help", "tagPosition", "tagContent", "innerButton", "showCopy", "copyText", "disabled", "tooltipTitle", "tooltipPosition", "onChange", "defaultValue"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      pswVisible = _useState4[0],
      setPswVisible = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultValue || ''),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      currentValue = _useState6[0],
      setCurrentValue = _useState6[1];

  var handleFocus = (0, _react.useCallback)(function (e) {
    setFocused(true);
    onFocus(e);
  }, [onFocus]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    setFocused(false);
    onBlur(e);
  }, [onBlur]);
  var handleOnChange = (0, _react.useCallback)(function (e) {
    setCurrentValue(e.target.value);
    if (onChange) onChange(e);
  }, [onChange, setCurrentValue]);
  var handleClick = (0, _react.useCallback)(function () {
    setPswVisible(!pswVisible);
  }, [pswVisible]);
  return (0, _jsxRuntime.jsxs)("div", {
    css: _Field.styles.fieldContainer,
    className: className,
    children: [label && (0, _jsxRuntime.jsxs)("div", {
      css: _Field.styles.labelBox,
      children: [(0, _jsxRuntime.jsx)("label", {
        htmlFor: name,
        children: label
      }), tooltipTitle && (0, _jsxRuntime.jsx)(_Tooltip["default"], {
        position: tooltipPosition,
        title: tooltipTitle,
        strategy: "fixed",
        children: (0, _jsxRuntime.jsx)(_icons.Question, {
          tabIndex: -1
        })
      })]
    }), (0, _jsxRuntime.jsxs)(FormControl, {
      focused: focused,
      validateStatus: validateStatus,
      disabled: disabled,
      children: [tagContent && (0, _jsxRuntime.jsx)(Tag, {
        tagPosition: tagPosition,
        tagContent: tagContent,
        children: tagContent
      }), (0, _jsxRuntime.jsx)("input", _objectSpread({
        id: name,
        name: name,
        type: pswVisible ? 'text' : htmlType,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onChange: handleOnChange,
        disabled: disabled,
        ref: ref,
        className: "grui truncate",
        css: _elements.input.styles.preflight,
        defaultValue: defaultValue
      }, otherProps)), htmlType === 'password' && (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "grui",
        css: [_elements.button.styles.preflight, _Field.styles.pswIcon, process.env.NODE_ENV === "production" ? "" : ";label:Field;"],
        onClick: handleClick,
        children: pswVisible ? (0, _jsxRuntime.jsx)(_icons.EyeOff, {}) : (0, _jsxRuntime.jsx)(_icons.Eye, {})
      }), !showCopy && innerButton && (0, _jsxRuntime.jsx)("div", {
        css: _Field.styles.innerButton,
        children: innerButton
      }), showCopy && (0, _jsxRuntime.jsx)("div", {
        css: _Field.styles.innerButton,
        children: (0, _jsxRuntime.jsx)(_CopyText["default"], {
          text: currentValue,
          children: (0, _jsxRuntime.jsx)(_Button["default"], {
            type: "primary",
            size: "small",
            children: copyText
          })
        })
      })]
    }), help && (0, _jsxRuntime.jsx)(_Help["default"], {
      help: help,
      validateStatus: validateStatus
    })]
  });
});
Field.propTypes = {
  label: _propTypes.string,
  name: _propTypes.string,
  // For input's type attribute
  htmlType: _propTypes.string,
  className: _propTypes.string,
  onFocus: _propTypes.func,
  onBlur: _propTypes.func,
  onChange: _propTypes.func,

  /**
   * ValidateStatus is for showing validation result
   * help is for validation hint
   */
  validateStatus: (0, _propTypes.oneOf)(['success', 'error']),
  help: _propTypes.string,

  /**
   * Preset or suffix tag
   */
  tagPosition: (0, _propTypes.oneOf)(['left', 'right']),
  tagContent: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  innerButton: _propTypes.node,
  disabled: _propTypes.bool,
  tooltipTitle: _propTypes.string,
  tooltipPosition: (0, _propTypes.oneOf)(_Tooltip.positions),
  showCopy: _propTypes.bool,
  copyText: _propTypes.node,
  defaultValue: _propTypes.string
};
Field.defaultProps = {
  label: undefined,
  name: undefined,
  htmlType: 'text',
  className: undefined,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  validateStatus: undefined,
  help: undefined,
  tagPosition: 'left',
  tagContent: undefined,
  innerButton: undefined,
  disabled: false,
  tooltipTitle: undefined,
  tooltipPosition: 'top',
  showCopy: false,
  copyText: 'Copy',

  /**
   * Default value for defaultValue need to be undefined to fix this warning (when value prop isn't undefined):
   * Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both).
   */
  defaultValue: undefined
};
Field.displayName = 'Field';
var _default = Field;
exports["default"] = _default;
//# sourceMappingURL=Field.js.map